'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/checkbox/style/css.js
// module id = 552
// module chunks = 0